<template>
  <v-row v-if="this.CanManageEmployeesAppointments && this.selectedUser" class="fill-height">
    <v-col style="padding-bottom: 0px;" cols="12" md="4" sm="4" xs="3">
      <v-sheet height="64px">
        <v-toolbar flat color="white">
          <v-combobox
            v-model="selectedUser"
            outlined
            dense
            :items="items"
            item-value="id"
            item-text="fullname"
            label="Select user"
            single-line
            hide-selected
            @change="SetSelectedUser"
          ></v-combobox>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SelectedUser",
  props: ["items"],
  computed: {
    CanManageEmployeesAppointments() {
      // if currently logged in user CanManageEmployeeAppointments
      // then
      // the select will appear on page
      return this.$store.getters.user.details.grouprole.find(
        r => r.roles.roleCode == "CMEA"
      );
    },
    selectedUser: {
      get() {
        return this.$store.getters.SelectedUser;
      },
      set(val) {
        this.$store.commit("setSelectedUser", val);
      }
    }
  },

  methods: {
    SetSelectedUser() {
      this.$emit("change", this.selectedUser);
    }
  }
};
</script>

<style>
</style>